"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
class AttributeShelf {
    constructor(initialValue, onSetValue) {
        this.onSetValue = null;
        this.setValue = (newValue) => {
            this.value = newValue;
            if (this.onSetValue) {
                this.onSetValue(this.value);
            }
        };
        this.value = initialValue;
        if (onSetValue) {
            this.onSetValue = onSetValue;
        }
        mobx_1.makeAutoObservable(this);
    }
}
exports.default = AttributeShelf;
